import { render } from "./App.vue?vue&type=template&id=1b59c61e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1b59c61e&lang=scss"

import exportComponent from "/builds/onitinc/busylamp/smart-invoice-converter/sic-frontend-core/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__